import session from "../../../services/session";
import swal from "sweetalert2";
import AdminApi from "../../../services/api";
import CONFIG_COMPANY from "../../../services/myConfig";
import Loc from "../../../services/localization";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            id: 0,
            expireDate: null,
            restOfTraining: '',
            role: '',
            model: {
                email: '',
                name: '',
                phone: '',
                surname: '',
                username: '',
                role: null
            },
            canExtendPayment: false
        }
    },
    methods: {
        load:load,
        update:update,
        deleteAccount: deleteAccount,
        signout: signout,
        resetPassword: resetPassword,
        extendPayment: extendPayment,
        myPayments: myPayments,
        formatDate:formatDate
    },
    beforeMount() {
        if(session.getRole() !== 'ROLE_ADMIN' && session.getRole() !== 'ROLE_SUPER_ADMIN' && session.getRole() !== 'ROLE_USER' && session.getRole() !== 'ROLE_TRAINER') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        this.role = session.getRole();
        this.canExtendPayment = session.getConfig().canExtendPayment;
        this.load()
    }
}

function load() {
    let _self = this;
    AdminApiService.getProfile()
        .then((response) => {
            _self.model = response.data;
            _self.expireDate = response.data.expireDate;
            if(response.data.restOfTraining > 50 && CONFIG_COMPANY.SHOW_INFINITY_TRAININGS){
                _self.model.restOfTraining = '∞'
            }else {
                _self.model.restOfTraining = '' + response.data.restOfTraining
            }
            // session.setCompanyPayment(response.data.companyPayment)
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function update() {
    let _self = this;
    AdminApiService.updateProfile(_self.model)
        .then((response) => {
            swal(LocService.t('label_success'), LocService.t('label_success_edit_profile'), 'success')
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function resetPassword() {
    this.$router.push('/reset-password');
}

function formatDate(date) {
    return this.$moment(new Date(date * 1000)).format('DD-MM-YYYY')
}

function deleteAccount(){
    let _self = this;
    swal({
        title: LocService.t('label_are_you_sure'),
        text: LocService.t('label_are_you_sure_to_delete_account'),
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t('label_no'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t('label_yes'),
        customClass: 'swal2-warning'
    }).then(function () {
        swal(LocService.t('label_success'), LocService.t('label_success_deleted'), 'success')
        setTimeout(function () {
            _self.$router.push('/login');
            _self.$sessionService.destroyUser();
        }, 800)
    });
}
function extendPayment(){
    let _self = this;
    AdminApiService.extendPayment()
        .then((response) => {
            swal(LocService.t('label_success'), LocService.t('label_success_extend_payment'), 'success')
            _self.load();
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function myPayments(){
    this.$router.push('/payment-user?id=' + this.model.id + '&name=' + this.model.name + ' ' + this.model.surname)
}

function signout(){
    this.$sessionService.destroyUser();
    this.$router.push('/login');
}


// WEBPACK FOOTER //
// ./src/components/Users/Profile/EditProfile.js